import { heroStats, site, tickers } from "@/mocks/chigua";

export default function Hero() {
  const marquee = [...tickers, ...tickers];
  return (
    <section id="home" className="relative overflow-hidden bg-background-50">
      {/* soft ambient blobs */}
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -right-20 top-40 h-80 w-80 rounded-full bg-accent-100/70 blur-3xl" />
      <div className="pointer-events-none absolute bottom-24 left-1/3 h-56 w-56 rounded-full bg-secondary-100/70 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-14 pt-28 md:gap-8 md:px-6 md:pb-20 md:pt-36 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="animate-rise">
          <div className="mb-5 inline-flex flex-wrap items-center gap-2">
            <span className="num-tab rounded-full bg-primary-500 px-3 py-1 text-[10px] tracking-[0.18em] text-background-50">
              {site.season} · 第 8 届
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-700 ring-1 ring-background-300">
              <i className="ri-fire-line text-primary-600" />
              年度瓜王终极对决 9.12 收官
            </span>
          </div>

          <h1 className="font-heading text-4xl font-bold leading-[1.16] tracking-wide text-foreground-950 md:text-6xl">
            吃瓜大赛
            <span className="text-primary-600">{site.season}</span>选手盘点
            <span className="mt-3 block text-2xl font-normal text-foreground-800 md:text-4xl">
              谁是最强黑马？瓜王只差你一票
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-8 text-foreground-700 md:text-lg md:leading-9">
            参赛名单与选手盘点全公开：娱乐圈、体育、商业、科技、直播电竞、社会民生六大赛区的热门选手、种子选手与候选事件一网打尽。
            从红毯反转、赛场争议到品牌奇案，看看今年哪颗瓜最有后劲。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#roster"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              围观完整参赛名单
              <i className="ri-arrow-right-line text-lg" />
            </a>
            <a
              href="#hot"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-100 px-6 py-3.5 text-sm font-semibold text-foreground-900 ring-1 ring-background-300 transition-colors hover:bg-background-200"
            >
              先看热门瓜料 TOP10
            </a>
          </div>

          <dl className="mt-10 grid max-w-xl grid-cols-4 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((s) => (
              <div key={s.label}>
                <dt className="order-2 text-xs text-foreground-600">{s.label}</dt>
                <dd className="num-tab text-2xl text-primary-600 md:text-3xl">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* decorative visual */}
        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative mx-auto aspect-[4/5] w-[86%] overflow-hidden rounded-[2.2rem] shadow-[0_0_0_1px_oklch(var(--background-200))] md:w-[76%] lg:w-[86%]">
            <img
              src="https://readdy.ai/api/search-image?query=playful%20editorial%20pop%20collage%20of%20fresh%20watermelon%20slices%20and%20lush%20green%20vines%20floating%20on%20a%20warm%20cream%20background%20with%20bold%20coral%20ranking%20numbers%2C%20trophy%20and%20sparkle%20accents%2C%20vibrant%20yet%20clean%20modern%20graphic%20design%20style%2C%20high%20contrast%2C%20soft%20natural%20studio%20lighting%2C%20appetizing%20and%20energetic%20summer%20mood&width=1000&height=1250&seq=gua-hero-deco&orientation=portrait"
              alt="吃瓜大赛2026选手盘点主题插画：水灵灵的西瓜与瓜藤元素组合成的榜单视觉"
              className="h-full w-full object-cover object-center"
              loading="eager"
            />
            <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-foreground-950/25 to-transparent" />
          </div>
          <div className="absolute -right-1 top-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-accent-500 text-center shadow-lg lg:-right-4 lg:h-24 lg:w-24">
            <span className="num-tab text-[10px] leading-tight tracking-wide text-background-50">
              GUA
              <br />
              TOP
            </span>
          </div>
          <div className="absolute -left-2 bottom-24 flex items-center gap-2 rounded-full bg-background-50 px-4 py-2.5 shadow-[0_0_0_1px_oklch(var(--background-200))] lg:-left-6">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-heart-3-fill" />
            </span>
            <div className="leading-tight">
              <p className="num-tab text-xs text-primary-600">920万+</p>
              <p className="text-[11px] text-foreground-600">瓜友正在围观</p>
            </div>
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="relative border-y border-background-200 bg-background-100/70 py-3">
        <div className="ticker-mask overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10 pr-10">
            {marquee.map((t, i) => (
              <span key={i} className="flex items-center gap-3 whitespace-nowrap text-sm text-foreground-700">
                <i className="ri-water-flash-fill text-primary-500" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}